import { ContentCard } from 'screens/blaze/Home/MobileHome/ContentCard/ContentCard'
import { WizardOpener } from '../WizardOpener/WizardOpener'
import { useNeedsUpgradeForChannelType } from 'hooks/useChannelNeedsUpgrade'
import { TextChannelKey } from 'types'
import { PricePill } from 'blaze-ui/Pricing/PricePill/PricePill'
import { CardContent, Wizard } from '../Types'

type Props = CardContent & {
  className?: string
  textWidth?: string | number
  imgScale?: number
  wizard?: Wizard
}

export const WizardCard = (props: Props) => {
  const { wizard, title, description, imgSrc, textWidth, imgScale, className, bottomLeftIcon } = props
  const { shouldForceUpgrade, nextTierPlan } = useNeedsUpgradeForChannelType()

  const renderCard = () => {
    return (
      <ContentCard
        className={className}
        title={title}
        description={description}
        imgSrc={imgSrc}
        badge={
          shouldForceUpgrade(wizard as TextChannelKey) && nextTierPlan ? (
            <PricePill plan={nextTierPlan.key} />
          ) : undefined
        }
        textWidth={textWidth}
        imgScale={imgScale}
        bottomLeftIcon={bottomLeftIcon}
      />
    )
  }

  if (wizard) {
    return <WizardOpener type={wizard}>{renderCard()}</WizardOpener>
  }

  return renderCard()
}
